// images
import simpleVoucherImage from '../../assets/images/Voucher-png-225.png';
import ottVoucherImage from '../../assets/images/ott_voucher.jpeg';
import DStvImage from '../../assets/images/DStv_Logo_2012.png';
import EskomElectricity from '../../assets/images/eskom-logo.png';
import waterImage from '../../assets/images/water.jpeg';
// icons
import TapAndPlayIcon from '@mui/icons-material/TapAndPlay';

const saServices = [
    {
        id: 'recharge-pinless',
        avatar: '',
        icon: <TapAndPlayIcon />,
        msg: 'Vodacom, CellC, MTN, 8ta',
        name: 'Airtime',
        link: '/recharge/pinless',
        btn: 'Buy Now'
    },
    {
        id: 'recharge-pinless-bundles',
        avatar: '',
        icon: <TapAndPlayIcon />,
        msg: 'Vodacom, CellC, MTN, 8ta',
        name: 'Data Bundles',
        link: '/recharge/pinless/bundles',
        btn: 'Buy Now'
    },
    {
        id: '#6',
        avatar: DStvImage,
        icon: '',
        name: 'DSTV Payments',
        link: '/recharge/multichoice',
        msg: 'SA Subscribers Only',
        btn: 'Pay Now'
    },
    {
        id: 'eskom-electricity',
        avatar: EskomElectricity,
        icon: '',
        name: 'Eskom Electricity',
        link: '/recharge/eskom-electricity',
        msg: 'Eskom Electricity Tokens',
        btn: 'Buy Now'
    },
    {
        id: 'ott-voucher',
        avatar: ottVoucherImage,
        icon: '',
        name: 'OTT Voucher',
        link: '/buy-ott-voucher',
        msg: 'Buy OTT Voucher',
        btn: 'Buy Now'
    },
    {
        id: '#simplevoucher',
        avatar: simpleVoucherImage,
        icon: '',
        name: 'Simple Voucher',
        link: '/buy-simple-voucher',
        msg: 'Buy Simple Voucher',
        btn: 'Buy Now'
    },
    {
        id: '#prepaidwater',
        avatar: waterImage,
        icon: '',
        name: 'Prepaid Water',
        link: '/pay/prepaid-water',
        msg: 'Pay Prepaid Water',
        btn: 'Pay Now'
    }
];

export default saServices;
